import { decode as base64Decode } from "base-64";
import CryptoJS from "crypto-js";

const secureKey = 'TEVHQUxfQURWSUNFX1NZUw==';
const secureIv = 'U1lTX0xFR0FMX0FEVklDRQ==';

export const encryptText = (text) => {
  const decodedKey = base64Decode(secureKey);
  const decodedIV = base64Decode(secureIv);

  console.log("decodedKey", decodedKey);
  console.log("decodedIV", decodedIV);

  const key = CryptoJS.enc.Utf8.parse(decodedKey);
  const iv = CryptoJS.enc.Utf8.parse(decodedIV);

  let encrypted = CryptoJS.AES.encrypt(text, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
  });

  encrypted = encrypted.toString();

  console.log("Encrypted Text:", encrypted);
  return encrypted;
};
